/**
 * Pre-compiled pt-BR messages for ComboBox
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearSelection: `Limpar seleção`,
  options: `Menu de opções`,
  selectedValues: `Selecionar valores`,
  toggleOptions: `Alternar opções`,
};
